export const routes = (parentName) => {
  return [
    {
      path: "teachers",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Teachers`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Teachers-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Teachers-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Teachers-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
